import {addParamToUrl, getUrlParameter, removeParamFromUrl} from "./utils/urlHelpers";
import {initCarousels} from "./utils/carousel";

const searchInput = document.querySelector(".main-search-form input");

function getFilteredPages(q, p, slideUp) {
    const results = $("#search-results");

    let url = "/parts/filtered-pages?q=" + q;

    if(p) {
        url += "&page=" + p;
    }

    $.ajax({
        url: url,
        method: "GET",
        beforeSend: function() {
            $(".grid-item-placeholder").show();
        },
        error: function(err) {
            console.log(err);
        },
        success: function(r) {
            $(".pagination").removeClass("disabled");
            $("#pagination-next-button").attr("disabled", false);
            if(slideUp) {
                $('html, body').animate({
                    scrollTop: $(".place-grid-wrap").offset().top - 90
                }, 10);
            }

            results.html(r);

            let placesCount = $(".place-grid-item").length;

            if(placesCount > 2) {
                $("#search-footer-button").hide();
            } else {
                $("#search-footer-button").show();
            }

            initCarousels();
        }
    })
}

$(function() {
    removeParamFromUrl('search');

    const query = getUrlParameter("q");
    const p = getUrlParameter("p");
    if(query.length) {
        searchInput.value = query;

        getFilteredPages(query, p);
    }

    $(document).on('click', '.pagination-item', function () {
        const page = $(this).data("page");
        addParamToUrl("p", page);
        $("#pagination-next-button").attr("disabled", true);
        $(".pagination").addClass("disabled");

        getFilteredPages(query, page, true);
    });

    $(document).on('click', '#pagination-next', function () {
        const current = $(".pagination-item--current");
        current.next().click();
    });

    $(document).on('click', '#pagination-prev', function () {
        const current = $(".pagination-item--current");
        current.prev().click();
    });

    $(document).on('click', '#pagination-next-button', function () {
        const current = $(".pagination-item--current");
        current.next().click();
    });
});

window.addEventListener('popstate', function(event) {
    // The popstate event is fired each time when the current history entry changes.
    window.location.reload();
}, false);